export const getDay = (timeStamp) => {
  const date = new Date(timeStamp);
  const day = date.getDate();
  return day;
};

export const getMonth = (timeStamp) => {
  const date = new Date(timeStamp);
  const month = new Intl.DateTimeFormat('tr', { month: 'short' })
    .format(date)
    .toUpperCase();
  const firstThreeLetters = month.substring(0, 3);
  return firstThreeLetters;
};

export const getDayFromDate = (dateString) => {
  const [day] = dateString.split('/');
  return parseInt(day, 10);
};

export const formatDate = (settlementDate) => {
  if (!settlementDate) return '';

  const [day, month, year] = settlementDate.split('/').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));

  return new Intl.DateTimeFormat('tr-TR', {
    day: 'numeric',
    month: 'long',
    weekday: 'long',
  }).format(date);
};

export const formatDashboardDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString.replace(' ', 'T'));

  const gun = date.getDate();
  const ay = date.toLocaleString('tr-TR', { month: 'long' });
  const yil = date.getFullYear();
  const saat = String(date.getHours()).padStart(2, '0');
  const dakika = String(date.getMinutes()).padStart(2, '0');

  return `${gun} ${ay} ${yil}, ${saat}.${dakika}`;
};

export const formatDateToTurkishLong = (dateStr) => {
  const [day, month, year] = dateStr.split('/');
  const date = new Date(year, month - 1, day);

  const formatter = new Intl.DateTimeFormat('tr-TR', {
    day: 'numeric',
    month: 'long',
    weekday: 'long',
  });
  let formatted = formatter.format(date);
  formatted = formatted.replace(/(\d+ \w+) (\w+)/, '$1, $2');

  return formatted;
};

/**
 *
 * @param { string } timestamp
 * @param { object } options
 * @param { string } options.dateHourSeparator
 * @param { boolean } options.spaceAfterDate
 * @returns { string }
 */
export const formatTimestamp = (
  timestamp,
  options = {
    dateHourSeparator: '-',
    spaceAfterDate: true,
  },
) => {
  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}.${month}.${year}${options.spaceAfterDate ? ' ' : ''}${
    options.dateHourSeparator
  } ${hours}:${minutes}`;
};

export const formatDateToString = (date) => {
  if (!date) return null;

  if (typeof date === 'string') return date;

  // Api Timestamp desteklemiyor o yüzden ise DD/MM/YYYY formatına çevirildi (API için)
  const dateObj = new Date(date);
  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = dateObj.getFullYear();

  return `${day}/${month}/${year}`;
};

export const parseDateString = (dateString) => {
  if (!dateString) return null;

  // Api de Timestamp donusumu yapilir diye eklendi
  if (typeof dateString === 'number') return dateString;

  // String ise DD/MM/YYYY formatından timestamp'e çevir DatePicker için
  if (typeof dateString === 'string' && dateString.includes('/')) {
    const [day, month, year] = dateString.split('/');
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    return date.getTime();
  }

  return null;
};
